import {
    UPI_DEEPLINK_TYPE,
} from 'entities/payment-methods/constants';

import styles from '../DeepLinkButton.module.scss';

export function formatIconClassName(type: UPI_DEEPLINK_TYPE): string {
    switch (type) {
        case UPI_DEEPLINK_TYPE.UPI: {
            return styles.upiIcon;
        }
        case UPI_DEEPLINK_TYPE.PAYTM: {
            return styles.paytmIcon;
        }
        case UPI_DEEPLINK_TYPE.PHONEPE: {
            return styles.phonepeIcon;
        }
        case UPI_DEEPLINK_TYPE.GPAY: {
            return styles.gpayIcon;
        }
    }
}
